export const isTempEmail = (email: string): boolean =>
  email.startsWith('generated_') && email.endsWith('shop-apotheke.com')

export const isUnspecifiedTempUser = (salutation: string): boolean =>
  salutation === 'unspecified'
